import { Component, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
// import { Chart } from 'chart.js';
import { MatTabChangeEvent } from '@angular/material';
import {animate, state, style, transition, trigger} from '@angular/animations';
// import { ChartType, ChartEvent } from 'ng-chartist';


// declare var coeffcall : any;
// declare var xLabel : any;
declare var numeric : any;
// declare var Chart : any;
// declare var require : any;

// declare var ACN_C18,ACN_C18Aq,ACN_C18Ul,ACN_IBD,ACN_PFPP,ACN_BIP,ACN_C8 :any;
// declare var MEOH_C18,MEOH_C18Aq,MEOH_C18Ul,MEOH_IBD,MEOH_PFPP,MEOH_BIP,MEOH_C8 :any;
// declare var compdata : any;

// export interface Chart {
//   type: ChartType;
//   data: Chartist.IChartistData;
//   options?: any;
//   responsiveOptions?: any;
//   events?: ChartEvent;
// }


@Component({
  selector: 'app-view2',
  templateUrl: './view2.component.html',
  styleUrls: ['./view2.component.css'],
  animations: [trigger(
        'displayChart', [
        transition(':enter', [
          style({opacity: 0}),
          animate('100ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('100ms', style({opacity: 0}))
        ])
      ])]
})

export class View2Component implements OnInit {

public displayChart : boolean = false;
public drawChart : any;
public chartType : any;
public chartData : any;
public countArray : [0,1,2,3,4,5];
public i : number;

// public var ACN_C18,ACN_C18Aq,ACN_C18Ul,ACN_IBD,ACN_PFPP,ACN_BIP,ACN_C8 :any;
// public var MEOH_C18,MEOH_C18Aq,MEOH_C18Ul,MEOH_IBD,MEOH_PFPP,MEOH_BIP,MEOH_C8 :any;
// declare var compdata : any;




// -------- Data Acquisition Tab - Table variables
    displayedColumns = ['position', 'name', 'weight', 'symbol', 'AUC'];
    dataSource = new MatTableDataSource<Element>(ELEMENT_DATA);

     type = 'line';
     options = {
        responsive: true,
        maintainAspectRatio: false
    };

// -------- LC Time Prog. Tab - Table variables
    LCColumns = ['time', 'solvent'];
    LCSource = new MatTableDataSource<LCtable>(LC_DATA);

// -------- LC Time Prog. Tab - Chart variables

LCtype = 'line';
LCdata = {
  labels: ["0", "5", "10", "15", "20", "25", "30"],
  datasets: [
    {
      label: "Undefined",
      data: [10, 10, 12, 0, 3, 6, 12]
    }
  ]
  };

LCoptions = {
    responsive: true,
    maintainAspectRatio: false
};

public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    console.log(tabChangeEvent);
    if (tabChangeEvent.index == 2) {
      console.log("THIS IS THE TAB!");
      this.LCtype = 'line';
      this.LCdata = {
        labels: ["0", "5", "10", "15", "20", "25", "30"],
        datasets: [
          {
            label: "Undefined",
            data: [10, 10, 12, 0, 3, 6, 12]
          }
        ]
        };

      this.LCoptions = {
          responsive: true,
          maintainAspectRatio: false
      };
    }
}



//tab2 enable solvent c
  solventc=false;

//Column Tab enable Advanced
    advanced=false;


solvents = [
  {value: 'MeOH', viewValue: 'MeOH'},
  {value: 'CAN', viewValue: 'CAN'},
  {value: 'Mix', viewValue: 'Mix'}
];

modes = [
  {value: 'Isocratic', viewValue: 'Isocratic'},
  {value: 'Gradient', viewValue: 'Gradient'}
];

initials = [
  {value: 5, viewValue: 5 },
  {value: 30, viewValue: 30 }
];

gradients = [
  {value: 5, viewValue: 5},
  {value: 10, viewValue: 10},
  {value: 15, viewValue: 15},
  {value: 20, viewValue: 20}
];

pressures = [
  {value: 3500, viewValue: 3500},
  {value: 7500, viewValue: 7500}
];

temperatures = [
  {value: "Ambient", viewValue: "Ambient"},
  {value: 40, viewValue: 40},
  {value: 50, viewValue: 50}
];

phases = [
  {value: "C18", viewValue: "C18"},
  {value: "IDB", viewValue: "IDB"},
  {value: "PFPP", viewValue: "PFPP"},
  {value: "Phenyl", viewValue: "Phenyl"},
  {value: "C18 Aqueous", viewValue: "C18 Aqueous"}
];

lengths = [
  {value: 50, viewValue: 50},
  {value: 100, viewValue: 100},
  {value: 150, viewValue: 150},
  {value: 250, viewValue: 250}
];

diameters = [
  {value: 2.1, viewValue: 2.1},
  {value: 3.2, viewValue: 3.2},
  {value: 4.6, viewValue: 4.6}
];

particles = [
  {value: 1.9, viewValue: 1.9},
  {value: 3, viewValue: 3},
  {value: 5, viewValue: 5},
  {value: "coreshell", viewValue: "coreshell"}
];

carbons = [
  {value: 20, viewValue: 20},
  {value: 11, viewValue: 11},
  {value: "?", viewValue: "?"}
];

pores = [
  {value: 100, viewValue: 100},
  {value: 140, viewValue: 140},
  {value: "?", viewValue: "?"}
];

samples = [
  {value: 0.1, viewValue: 0.1},
  {value: 0.05, viewValue: 0.05}
];

  constructor() {
    //EXTERNAL JS HERE

    // var ACN_C18,ACN_C18Aq,ACN_C18Ul,ACN_IBD,ACN_PFPP,ACN_BIP,ACN_C8
    // var MEOH_C18,MEOH_C18Aq,MEOH_C18Ul,MEOH_IBD,MEOH_PFPP,MEOH_BIP,MEOH_C8
    // var compdata;
  var i =1;
  var  compdata = [[0.094128039,-0.84085387,256.7,16877,4.50],   //SUL
                [0.115845745,-2.497049303,211.9,10773,5.30],  //PIR
                [0.072987396,0.055242831,262.7,11190,4.52],   //PHE
                [0.078695187,1.586241386,192.2,6793,4.15],    //NAPR
                [0.0976261,1.571312236,212.2,26831,3.70],     //KETO
                [0.095900704,0.400611442,206.8,9511,3.99]     //DICL
                ];
  var  ACN_C18=[[-4.482973,631.078396,-4.764670,7.963999],
            [-0.878722,194.649688,6.245336,-1.546843],
            [-3.1446748,483.778781,-1.395124,6.485762],
            [-3.713306,496.575343,-4.144739,7.617909],
            [-3.431738,482.969102,-2.521540,6.323179],
            [-3.427969,507.941665,-2.160538,7.037518]];
  var  ACN_C18Aq=[[-2.296608,477.935991,6.412758,-0.026647],
            [0.017964,184.849416,11.935544,-5.642432],
            [-2.831418,447.734636,0.578158,5.068236],
            [-2.886890,490.250599,2.203269,3.086675],
            [-2.887796,476.661932,1.726325,3.331015],
            [-2.778376,501.806827,3.620103,3.000004]];
  var ACN_C18Ul=[[-2.721223,368.893390,1.581798,3.442117],
            [-1.640425,307.610809,2.303481,1.488290],
            [-2.314977,365.903562,-0.102931,5.556761],
            [-2.430924,399.191606,1.561520,3.451664],
            [-2.365378,380.347190,1.824854,3.292460],
            [-2.409671,425.524407,1.947519,4.107272]];
  var  ACN_IBD=[[-1.325601,393.065907,9.111769,-2.218606],
            [-1.466119,307.176379,1.908059,1.397862],
            [-2.675357,443.155596,-0.110794,5.308507],
            [-2.048054,448.265844,4.582856,1.121499],
            [-1.912695,410.564499,4.688182,1.008902],
            [-2.053667,500.941275,4.610699,1.856949]];
  var  ACN_PFPP=[[-3.956585,748.280334,4.638899,1.790935],
            [-1.174476,354.585859,6.120581,-2.225579],
            [-4.529537,787.895749,-2.364145,6.945119],
            [-4.532341,846.527971,0.370268,4.554628],
            [-4.405609,787.272053,0.420975,4.585913],
            [-4.938476,922.312140,-0.512392,5.904548]];
  var  ACN_BIP=[[-2.361307,418.012955,5.135169,0.695216],
            [0.536662,33.133737,12.828914,-6.416565],
            [-2.756066,451.085354,1.786521,3.980652],
            [-2.630463,445.163023,3.541866,1.971183],
            [-2.555079,421.120221,3.575024,1.950289],
            [-2.575648,415.459749,3.289273,3.011113]];
  var  ACN_C8=[[0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000]];
  var  MEOH_C18=[[-3.713050,708.172534,4.506640,3.200922],
            [-2.164328,489.670471,4.848679,0.048011],
            [-3.420687,598.442166,0.945560,5.540639],
            [-3.452080,626.827602,0.832133,4.825746],
            [-3.396381,611.191910,1.891499,4.128107],
            [-4.063225,796.393669,-0.320508,6.645100]];
  var  MEOH_C18Aq=[[-3.607037,813.521188,5.215486,2.041321],
            [-2.428149,689.074523,6.114154,-0.977155],
            [-2.586383,464.386883,3.730201,3.045495],
            [-3.173093,655.138417,2.885355,2.767774],
            [-2.853719,567.244586,4.116767,1.952954],
            [-3.453766,734.487777,2.832095,3.776621]];
  var  MEOH_C18Ul=[[0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000]];
  var  MEOH_IBD=[[-2.195417,604.400891,6.888502,0.597443],
            [-1.072823,346.595024,2.551767,0.611579],
            [-1.439076,469.126195,6.796131,-0.138107],
            [-2.050122,493.925463,2.877597,2.382933],
            [-1.767591,405.450230,3.148777,2.024748],
            [-2.568547,665.345707,2.923421,3.597907]];
  var  MEOH_PFPP=[[0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000]];
  var  MEOH_BIP=[[-3.770895,955.310141,5.130040,2.315732],
            [-2.528668,761.358920,4.935890,0.228517],
            [-3.267191,764.333032,3.873845,3.195862],
            [-3.203992,740.585041,3.426571,2.523234],
            [-3.200504,745.802812,4.293874,2.224335],
            [-3.341131,756.094508,3.251050,3.751685]];
  var  MEOH_C8=[[0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000],
            [0.000000,0.000000,0.000000,0.000000]];
    //DATA ABOVE

    //FUNC BELOW
    var coeffcall = function(){
        //Return regression coeff based on solvent and column type
        var coeff;
        switch(solventPara.Type){
        case 'ACN':
            switch(columnPara.Type){
            case 'C18':coeff = ACN_C18;break;
            case 'C18Aq':coeff = ACN_C18Aq;break;
            case 'C18Ul':coeff = ACN_C18Ul;break;
            case 'IBD':coeff = ACN_IBD;break;
            case 'PFPP':coeff = ACN_PFPP;break;
            case 'BIP':coeff = ACN_BIP;break;
            case 'C8':coeff = ACN_C8;break;
            };
        break;
        case 'MEOH':
            switch(columnPara.Type){
            case 'C18':coeff = MEOH_C18;break;
            case 'C18Aq':coeff = MEOH_C18Aq;break;
            case 'C18Ul':coeff = MEOH_C18Ul;break;
            case 'IBD':coeff = MEOH_IBD;break;
            case 'PFPP':coeff = MEOH_PFPP;break;
            case 'BIP':coeff = MEOH_BIP;break;
            case 'C8':coeff = MEOH_C8;break;
            };
        break;
        };
        return coeff;
    }
    var VoidTVfunc = function(){
        //Return void time, void volume and linear velocity
        var VoidTV=[],TPoro;
        //Void time calculation
        TPoro = advancedPara.InterP + advancedPara.IntraP * (1-advancedPara.InterP);
        VoidTV[0] = TPoro*Math.PI*(columnPara.ID*columnPara.ID/400)*columnPara.L/10; //Column void volume (mL)
        VoidTV[1] = VoidTV[0]/systemPara.FlowRate; //Column void time (min)
        VoidTV[2] = columnPara.L/VoidTV[1]; //Linear velocity (mm/min)
        return VoidTV;
    }
    var rtfunc2 = function(phi,pH,Temp,i){
        //Return retention time based on PNM quad model
        //Input unit conversion
        var RF_iso;
        phi=phi/100;
        Temp=Temp+273.15;
        switch(solventPara.Type){
            case "ACN":var PNM=1-2.068*phi/(1+1.341*phi);break;
            case "MEOH":var PNM=1-1.33*phi/(1+0.47*phi);break;
            case "MIX":var PNM=0;break;
            }
        //Retention model
        var logk=coeff[i][0]+coeff[i][1]/Temp+coeff[i][2]*PNM*PNM+coeff[i][3]*PNM
        +Math.log10(1+Math.pow(10,(pH-compdata[i][4]-phi*compdata[i][1]))
        /(1+Math.pow(10,(pH-compdata[i][4]-phi*compdata[i][1])))*(compdata[i][0]-1));
        return RF_iso = Math.pow(10,logk);
    }
     var effuncs = function(FlowRate,RtFactor,dP,L,InterDiam,Vinj,A,B,C,phi,Temp,InterP,IntraP,t0,i){
        //Return efficiency and other results
        var EffResults = [];
        var visco,psi,MB;

        // Unit conversion
        var Temp = Temp+273.15;
        phi = phi/100;
        var TPoro = InterP + IntraP * (1-InterP);

        // Viscosity calculation
        switch(solventPara.Type){
            case "ACN":
            visco = Math.exp(phi*(-3.476+726/Temp)+(1-phi)*(-5.414+1566/Temp)+phi*(1-phi)*(-1.762+929/Temp));
            psi = 1*phi + 2.6*(1-phi);
            MB = 41.05*phi+ 18.015*(1-phi);
            break;
            case "MEOH":
            visco = Math.exp(phi*(-4.597+1211/Temp)+(1-phi)*(-5.961+1736/Temp)+phi*(1-phi)*(-6.215+2809/Temp));
            psi = 1.9*phi + 2.6*(1-phi);
            MB = 32.04*phi + 18.015*(1-phi);
            break;
            case "MIX":
            break;
        }
        // Retention time calculation
        var tR = (RtFactor[i]+1)*t0;

        // Reduced velocity calculation
        var ue = (TPoro/InterP)*L/t0/600;
        var Dm = 7.4e-8*(Math.sqrt(psi*MB))*Temp/(visco*Math.pow(compdata[i][2],0.6));
        var vr = ue*dP/Dm/10000;

        // Efficiency model
        var Ncoeff=[5.109e-6,0.0098326];
        var sigma2 = tR*tR*dP/L/1000*(A+B/vr+C*vr)+Ncoeff[0]*(Vinj/FlowRate)*(Vinj/FlowRate)+Ncoeff[1];
        var sigma = Math.sqrt(sigma2);
        var Efficiency = (tR/sigma)*(tR/sigma);
        var HETP = L/Efficiency;

        //EffResults = [sigma,N,t0,tR,visco,HETP,Vm]
        EffResults[0] = sigma;
        EffResults[1] = Efficiency;
        EffResults[2] = HETP;
        EffResults[3] = tR;
        EffResults[4] = visco;
        console.log("EFFRESULTS",EffResults);
        return EffResults;
    }
    var bpfuncs = function(visco,L,FR,dP,InterDiam){
        //Return backpressure value for the run

        //Input
        //visco - viscosity (cP)
        //L - column length (mm)
        //FR - flow rate (mL/min)
        //dP - column particle size (um)
        //InterDiam - column internal diameter (mm)

        //Output
        //BP - backpressure (psi)

        var BP;
        BP = 4000*L*FR*visco/(dP*dP)/(InterDiam*InterDiam);
        console.log("BACKPRESSURE", BP);
        return BP;
    }
var senfuncs=function(SampleConc,Vinj,Efficiency,RtFactor,Vm,sigma,i){
        //Return AUC value for compounds

        //Input
        //Conc - Sample concentration for the compounds (mg/ml) [6x1]
        //Vinj - injection volume (uL)
        //N - column efficiency (-) [6x1]
        //k - retention factor (-) [6x1]
        //Absorb - Absorbivity of compounds (-) [6x1]
        //Vm - column void volume (mL)
        //sigma - standard deviation (min)

        //Output
        //AUC - Area under curve (-)
        var Cs,H,AUC
        Cs = SampleConc*Vinj*Math.sqrt(Efficiency)/(Vm*(1+RtFactor));
        H = compdata[i][3]*Cs;
        /*if (H>4e6){
            H = 4e6;
        }*/
        AUC = 37.46*(4*sigma)*H;
        return AUC;
    }
var normdisfun = function(tR,sigma,AUC,x_max){
        //Density function
        var datapoint = 2000;
        var i,n,dx,densityFunc=[],normdis=[],x=[];
        var y = Array.apply(null, Array(datapoint)).map(Number.prototype.valueOf,0);
        dx=x_max/datapoint;
        for (let n of Array(datapoint)){
            x[n]=n*dx;

            for (let i in Array(6)){
                densityFunc[n]=1/Math.sqrt(2*Math.PI*sigma[i]*sigma[i])*Math.exp(-(dx*n-tR[i])*(dx*n-tR[i])/(2*sigma[i]*sigma[i]))*AUC[i];
                y[n]=y[n]+densityFunc[n];
            }
        }
        normdis[0]=x;
        normdis[1]=y;
        console.log("NORMDIS",normdis);
        return normdis;
    }
var xydata = function(x,y,dataNo){
        var i,dataset=[];
        for (let i in dataNo){
            dataset[i] = {x:x[i],y:y[i]};
        }
        console.log("DATASET",dataset);
        return dataset;
    }

    // Gradient functions
    var concgrad = function(tstamp,concp,tpoint){
        //Return gradient profile based on user input profile
         var grads=[],i
         for (let i in tpoint){
             grads[i]=(concp[i+1]-concp[i])/(tstamp[i+1]-tstamp[i]);
         }
         return grads;
    }
     var concfuncs = function(t,tstamp,concp,tpoint,grad){
        //Concentration time
        var phi;
        if (t >= tstamp[tpoint-1]){
                phi = concp[tpoint-1];
            }
        else {
            var j;
            for (j in tpoint){
                if (t < tstamp[j]){
                    phi = grad[j-1]*(t-tstamp[j-1]) + concp[j-1];
                    break
                }
            }
        }
        return phi;
    }
    var rtfuncg = function(t,i){
        //Retention factor time function
        //Input unit conversion
        var RtFactori;
        var phi = concfuncs(t,tstamp,concp,tpoint,grads)/100;
        var Temp = systemPara.Temp +273.15;

        switch(solventPara.Type){
            case "ACN":var PNM = 1-2.068*phi/(1+1.341*phi);break;
            case "MEOH":var PNM = 1-1.33*phi/(1+0.47*phi);break;
            case "MIX":var PNM = 0;break;
            }

        //Retention model
        var logki = coeff[i][0] + coeff[i][1]/Temp + coeff[i][2]*PNM*PNM + coeff[i][3]*PNM
            + Math.log10(1 + Math.pow(10,(solventPara.pH-compdata[i][4]-phi*compdata[i][1]))
            /(1+Math.pow(10,(solventPara.pH-compdata[i][4]-phi*compdata[i][1])))*(compdata[i][0]-1));
        return RtFactori = Math.pow(10,logki);
    }
    var effuncg = function(t,i){
        //Efficiency time function

        //Unit conversion
        var Temp=systemPara.Temp+273.15;
        var phi=concfuncs(t,tstamp,concp,tpoint,grads)/100;
        var TPoro=advancedPara.InterP + advancedPara.IntraP * (1-advancedPara.InterP);

        //Viscosity calculation
        var visco,psi,MB;
        switch(solventPara.Type){
            case "ACN":
            visco = Math.exp(phi*(-3.476+726/Temp)+(1-phi)*(-5.414+1566/Temp)+phi*(1-phi)*(-1.762+929/Temp));
            psi = 1*phi + 2.6*(1-phi);
            MB = 41.05*phi+ 18.015*(1-phi);
            break;
            case "MEOH":
            visco = Math.exp(phi*(-4.597+1211/Temp)+(1-phi)*(-5.961+1736/Temp)+phi*(1-phi)*(-6.215+2809/Temp));
            psi = 1.9*phi + 2.6*(1-phi);
            MB = 32.04*phi + 18.015*(1-phi);
            break;
            case "MIX":
            break;
        }

        //Instaneous retention time calculation
        var RTimei = (rtfuncg(t,i)+1)*t0;

        //Reduced velocity calculation
        var ue = (TPoro/advancedPara.InterP)*columnPara.L/t0/600;
        var Dm = 7.4e-8*(Math.sqrt(psi*MB))*Temp/(visco*Math.pow(compdata[i][2],0.6));
        var vr = ue*columnPara.PS/Dm/10000;

        // Instaneous HETP calculation
        var Ncoeff= [5.109e-6,0.0098326];
        var sigma2i = RTimei*RTimei*columnPara.PS/columnPara.L/1000*(advancedPara.A+advancedPara.B/vr
            +advancedPara.C*vr)+Ncoeff[0]*(systemPara.Vinj/systemPara.FlowRate)*(systemPara.Vinj/systemPara.FlowRate)+Ncoeff[1];
        var sigmai = Math.sqrt(sigma2i);
        var Efficiencyi = (RTimei/sigmai)*(RTimei/sigmai);
        var HETPi = columnPara.L/Efficiencyi;
        return HETPi;
    }
     var bpfuncg = function(t_max,datapoint){
        //Viscosity calculation
        var Temp=systemPara.Temp+273.15;
        var n,BP=[],t=[];
        var dt=t_max/datapoint;
        for (let n of datapoint){
            t[n]=n*dt;
            var phi=concfuncs(t[n],tstamp,concp,tpoint,grads)/100;
            switch(solventPara.Type){
                case "ACN":
                var visco = Math.exp(phi*(-3.476+726/Temp)+(1-phi)*(-5.414+1566/Temp)+phi*(1-phi)*(-1.762+929/Temp));
                break;
                case "MEOH":
                var visco = Math.exp(phi*(-4.597+1211/Temp)+(1-phi)*(-5.961+1736/Temp)+phi*(1-phi)*(-6.215+2809/Temp));
                break;
                case "MIX":
                break;
            }
            BP[n]=4000*columnPara.L*systemPara.FlowRate*visco/(columnPara.PS*columnPara.PS)/(columnPara.ID*columnPara.ID);
        }
        var BPResults=[];
        BPResults[0]=t;
        BPResults[1]=BP;
        return BPResults;
    }
    var senfuncg=function(Conc,Vinj,N,k,Vm,sigma,i){
        //Return AUC value for compounds

        //Input
        //Conc - Sample concentration for the compounds (mg/ml) [6x1]
        //Vinj - injection volume (uL)
        //N - column efficiency (-) [6x1]
        //k - retention factor (-) [6x1]
        //Absorb - Absorbivity of compounds (-) [6x1]
        //Vm - column void volume (mL)
        //sigma - standard deviation (min)

        //Output
        //AUC - Area under curve (-)
        var Cs,H,AUC
        Cs = Conc*Vinj*Math.sqrt(N)/(Vm*(1+k));
        H = compdata[i][3]*Cs;
        if (H>4e6){
            H = 4e6;
        }
        AUC = 37.46*(4*sigma)*H;
        return AUC;
    }

    var gradodefunc=function(zValue,sValues){
      /*
      % System of ordinary derivative equations
      % s(1) - t
      % s(2) - sigma^2

      % dsdz(1) - dt/dz
      % dsdz(2) - d(sigma^2)/dz
      */

      var dt = 1e-6;
      var dlambdadt = (lambdafun(zValue,sValues[0]+dt)-lambdafun(zValue,sValues[0]-dt))/(dt*2);
      var dlambdadt2 = (lambdafun(zValue,sValues[0]+dt)-2*lambdafun(zValue,sValues[0])+lambdafun(zValue,sValues[0]-dt))/(dt*2);
      var dsdz =[];
      dsdz[0] = lambdafun(zValue,sValues[0]);
      dsdz[1] = HETPfunc(zValue,sValues[0])*lambdafun(zValue,sValues[0])*lambdafun(zValue,sValues[0])
                +2*sValues[1]*dlambdadt;//+ 16*dlambdadt2;
      return dsdz;
      }
     var lambdafun = function(zValue, tValue){
        var lambda;
        lambda = (1+rtfuncg(tValue-zValue/u0,i))/u0;
        return lambda;
    }

     var HETPfunc = function(zValue,tValue){
        var HETP;
        HETP = effuncg(tValue-zValue/u0,i);
        return HETP;
    }
    //FUNC ABOVE ------------------------------------------------------------------------------------------------------------------------

    //CAL BELOW ------------------------------------------------------------------------------------------------------------------------
    //User defined parameteres
    var columnPara = {Type:"C18",L:150,ID:4.6,PS:5};
    var solventPara = {Type:"ACN",pH:3,Conc:40};
    var systemPara = {Temp:30,FlowRate:1.5,Vinj:20,AcqTime:20};
    var advancedPara = {InterP:0.4,IntraP:0.4,A:0.02,B:12.168,C:0.02};
    var samplePara = [0.1,0.1,0.1,0.1,0.1,0.1]; //[SUL,PIR,PHE,NAP,KET,DIC]

    //Calling from database
     var coeff = coeffcall();

    //Calculating responses
      //System response
      //Void time and void volume
       var VoidTV = VoidTVfunc();
       var t0=VoidTV[1];
       var Vm=VoidTV[0];
       var u0=VoidTV[2];

      //Isocratic mode
        //Looping for each compound
          //Defining variables
        var RF_iso=[];
        var EffResults_iso=[];
        var sigma_iso=[];
        var EffN_iso=[];
        var RTime_iso=[];
        var HETP=[];
        var AUC_iso=[];
        // let countArray = [0,1,2,3,4,5];
        // for(let i in this.countArray){
        //   //Retention calculation
        //   RF_iso[i]=rtfunc2(solventPara.Conc,solventPara.pH,systemPara.Temp,i);
        //   //Efficiency calculation
        //   EffResults_iso=effuncs(systemPara.FlowRate,RF_iso,columnPara.PS,columnPara.L,columnPara.ID,systemPara.Vinj,advancedPara.A,
        //   advancedPara.B,advancedPara.C,solventPara.Conc,systemPara.Temp,advancedPara.InterP,advancedPara.IntraP,t0,i);
        //   sigma_iso[i]=EffResults_iso[0];
        //   EffN_iso[i]=EffResults_iso[1];
        //   HETP[i]=EffResults_iso[2];
        //   RTime_iso[i]=EffResults_iso[3];
        //   //Sensitivity calculation
        //   AUC_iso[i]=senfuncs(samplePara[i],systemPara.Vinj,EffN_iso[i],RF_iso[i],Vm,sigma_iso[i],i)
        // }
          //Backpressure
           var visco=EffResults_iso[4];
           console.log("VISCO", visco);
           var backPressure_iso=bpfuncs(visco,columnPara.L,systemPara.FlowRate,columnPara.PS,columnPara.ID)

           var normdis_iso= normdisfun(RTime_iso,sigma_iso,AUC_iso,systemPara.AcqTime);
           var chromatogram_iso = xydata(normdis_iso[0],normdis_iso[1],normdis_iso[0].length);
          //Checking point
          console.log("CHROMATOGRAM ISO",chromatogram_iso);

      //Gradient mode
        //Additional parameteres
         var tstamp = [0,3,8,20];
         var concp = [30,30,100,100];
         var tpoint = tstamp.length;

        //Plot concentration time profile
         var grads = concgrad(tstamp,concp,tpoint);
         var concProfile=xydata(tstamp,concp,tstamp.length);

        //Backpressure
         var BPResults=bpfuncg(systemPara.AcqTime,500);
         var backPressure_grad=xydata(BPResults[0],BPResults[1],BPResults[0].length);
        console.log("BACKPRESSURE GRAD", backPressure_grad);
        console.log("CONCPROFILE", concProfile);

        //Looping for each compound
         var RF_grad=[];
         var sigma_grad=[];
         var AUC_grad=[];
         var EffN_grad=[];
         var RTime_grad=[];



        // setup = function(i,x) {
        for (let i in Array(this.countArray) ){
        var myI = Number(i);

        console.log("THIS I IN ARRAY =",myI)
          //ode solver
          var odesolution=numeric.dopri(0,columnPara.L,[0,0],gradodefunc,1e-6,2000); //Herein lies the problem¿?
          console.log("ODESOLUTION =",odesolution)
          var odelength=odesolution.x.length;
          var RFi_grad=odesolution.y[odelength-1][0];
          var sigmai_grad=Math.sqrt(odesolution.y[odelength-1][1]);
          RF_grad[myI]=RFi_grad;
          sigma_grad[myI]=sigmai_grad;
          RTime_grad[myI]=t0*(1+RF_grad[myI]);
          EffN_grad[myI]= (RTime_grad[myI]/sigma_grad[myI])*(RTime_grad[myI]/sigma_grad[myI]);
          AUC_grad[myI]=senfuncs(samplePara[myI],systemPara.Vinj,EffN_grad[myI],RF_grad[myI],Vm,sigma_grad[myI],myI)

          ///// copied from above

          RF_iso[myI]=rtfunc2(solventPara.Conc,solventPara.pH,systemPara.Temp,myI);
          //Efficiency calculation
          var EffResults_iso=effuncs(systemPara.FlowRate,RF_iso,columnPara.PS,columnPara.L,columnPara.ID,systemPara.Vinj,advancedPara.A,
          advancedPara.B,advancedPara.C,solventPara.Conc,systemPara.Temp,advancedPara.InterP,advancedPara.IntraP,t0,myI);
          sigma_iso[myI]=EffResults_iso[0];
          EffN_iso[myI]=EffResults_iso[1];
          HETP[myI]=EffResults_iso[2];
          RTime_iso[myI]=EffResults_iso[3];
          //Sensitivity calculation
          AUC_iso[myI]=senfuncs(samplePara[myI],systemPara.Vinj,EffN_iso[myI],RF_iso[myI],Vm,sigma_iso[myI],myI)

        }

      // }

        // console.log(RF_grad);
        // console.log(sigma_grad);
        // console.log(AUC_grad);
         var normdis_grad= normdisfun(RTime_grad,sigma_grad,AUC_grad,systemPara.AcqTime);
         var chromatogram_grad = xydata(normdis_grad[0],normdis_grad[1],normdis_grad[0].length);

        //Checking point
        //console.log(chromatogram_grad);
    //CAL ABOVE

    //EXTERNAL JS ABOVE HERE

    // -------- CHROMATOGRAM - Chart variables

    this.drawChart = function() {
      this.chartType = 'scatter';
      this.chartData = {
            datasets: [
                {
                fill:false,
                label: 'Chromatogram',
                yAxesID:'Absorption',
                data: chromatogram_iso,
                borderColor: 'rgb(51, 102, 255)',
                showLine:true,
                pointRadius:0,
                borderWidth:2,
                cubicInterpolationMode:'monotone',
                steppedLine:'after'
              },{
                fill:false,
                label: 'Backpressure (psi)',
                yAxesID:'Backpressure',
                data: [{x:0,y:backPressure_iso},{x:systemPara.AcqTime,y:backPressure_iso}],
                borderColor: 'rgb(255, 80, 80)',
                showLine:true,
                pointRadius:0,
                borderWidth:2,
              },
              {
                fill:false,
                label: 'Void time',
                xAxesID:'Void',
                data: [{x:t0,y:0},{x:t0,y:4e7}],
                borderColor: 'rgb(150, 150, 150)',
                borderDash: [5, 5],
                showLine:true,
                pointRadius:0,
                borderWidth:2,
              }
            ]
            };
      this.chartOptions = {
          scales: {
                xAxes: [{
                    type: 'linear',
                    position: 'bottom',
                    id: 'Void'
                }],
                yAxes:[{
                  position:'left',
                  id:"Absorption",
                  ticks:{
                    max:4e7,
                    min:0
                    }
                  },{
                position:'right',
                id:"Backpressure",
                gridLines:{drawOnChartArea:false},
                ticks:{
                  max:6e3,
                  min:0
                }
                }]
            }
        };
      this.displayChart=!this.displayChart;
    }

  }

  ngAfterViewInit() {
    // console.log('afterViewInit => ', this.tabGroup.selectedIndex);
    // console.log('afterViewInit => ', normdis[0]);
 }

  ngOnInit() {

  }
}

export interface Element {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  AUC: number;
}

// function setup(i) {
//   //ode solver
//    odesolution=numeric.dopri(0,columnPara.L,[0,0],gradodefunc,1e-6,2000);
//    odelength=odesolution.x.length;
//    RFi_grad=odesolution.y[odelength-1][0];
//    sigmai_grad=Math.sqrt(odesolution.y[odelength-1][1]);
//   RF_grad[myI]=RFi_grad;
//   sigma_grad[i]=sigmai_grad;
//   RTime_grad[i]=t0*(1+RF_grad[i]);
//   EffN_grad[i]= (RTime_grad[i]/sigma_grad[i])*(RTime_grad[i]/sigma_grad[i]);
//   AUC_grad[i]=senfuncs(samplePara[i],systemPara.Vinj,EffN_grad[i],RF_grad[i],Vm,sigma_grad[i],i)
//
//   ///// copied from above
//
//   RF_iso[i]=rtfunc2(solventPara.Conc,solventPara.pH,systemPara.Temp,i);
//   //Efficiency calculation
//   EffResults_iso=effuncs(systemPara.FlowRate,RF_iso,columnPara.PS,columnPara.L,columnPara.ID,systemPara.Vinj,advancedPara.A,
//   advancedPara.B,advancedPara.C,solventPara.Conc,systemPara.Temp,advancedPara.InterP,advancedPara.IntraP,t0,i);
//   sigma_iso[i]=EffResults_iso[0];
//   EffN_iso[i]=EffResults_iso[1];
//   HETP[i]=EffResults_iso[2];
//   RTime_iso[i]=EffResults_iso[3];
//   //Sensitivity calculation
//   AUC_iso[i]=senfuncs(samplePara[i],systemPara.Vinj,EffN_iso[i],RF_iso[i],Vm,sigma_iso[i],i)
// }

const ELEMENT_DATA:
  Element[] = [
  {position: 20, name: 'Not sure what goes here', weight: 40.078, symbol: '??', AUC: 0.01}
];

export interface LCtable {
  time: number;
  solvent: number;
}

const LC_DATA:
LCtable[] = [
  { time: 1, solvent: 1.0079 }
];
